import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.SupplierPrioritiesPage.title',
    defaultMessage: 'Supplier Priorities',
  },
  subtitle: {
    id: 'containers.SupplierPrioritiesPage.subtitle',
    defaultMessage: 'Manage supplier priority profiles and their settings.',
  },
  columnName: {
    id: 'containers.SupplierPrioritiesPage.columnName',
    defaultMessage: 'Name',
  },
  columnCustomer: {
    id: 'containers.SupplierPrioritiesPage.columnCustomer',
    defaultMessage: 'Customer',
  },
  columnAgeRange: {
    id: 'containers.SupplierPrioritiesPage.columnAgeRange',
    defaultMessage: 'Age range',
  },
  columnVoiceStars: {
    id: 'containers.SupplierPrioritiesPage.columnVoiceStars',
    defaultMessage: 'Voice Stars',
  },
  noSelected: {
    id: 'containers.SupplierPrioritiesPage.noSelected',
    defaultMessage: 'Select a priority to edit its settings.',
  },
  editTitle: {
    id: 'containers.SupplierPrioritiesPage.editTitle',
    defaultMessage: 'Edit: {name}',
  },
  fieldAgeRange: {
    id: 'containers.SupplierPrioritiesPage.fieldAgeRange',
    defaultMessage: 'Age range',
  },
  fieldLanguages: {
    id: 'containers.SupplierPrioritiesPage.fieldLanguages',
    defaultMessage: 'Languages',
  },
  fieldProducts: {
    id: 'containers.SupplierPrioritiesPage.fieldProducts',
    defaultMessage: 'Preferred demo products',
  },
  fieldVoiceStars: {
    id: 'containers.SupplierPrioritiesPage.fieldVoiceStars',
    defaultMessage: 'Include all Voice Stars',
  },
  save: {
    id: 'containers.SupplierPrioritiesPage.save',
    defaultMessage: 'Save',
  },
  saving: {
    id: 'containers.SupplierPrioritiesPage.saving',
    defaultMessage: 'Saving…',
  },
  saved: {
    id: 'containers.SupplierPrioritiesPage.saved',
    defaultMessage: 'Saved',
  },
})
